import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { cn } from '../../utils/cn';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen: boolean;
  onToggle: () => void;
  index: number;
}
function AccordionItem({
  title,
  children,
  isOpen,
  onToggle,
  index
}: AccordionItemProps) {
  const headingId = `accordion-heading-${index}`;
  const panelId = `accordion-panel-${index}`;
  return <div className="border-b border-gray-200 last:border-0" data-id="element-13">
      <h3 data-id="element-14">
        <button id={headingId} className="w-full py-4 px-6 flex items-center justify-between bg-white hover:bg-gray-50 transition-colors text-left" onClick={onToggle} aria-expanded={isOpen} aria-controls={panelId} data-id="element-15">
          <span className="text-lg font-bold text-gray-800" data-id="element-16">{title}</span>
          {isOpen ? <ChevronUp className="w-5 h-5 text-gray-500 flex-shrink-0" aria-hidden="true" data-id="element-17" /> : <ChevronDown className="w-5 h-5 text-gray-500 flex-shrink-0" aria-hidden="true" data-id="element-18" />}
        </button>
      </h3>
      <div id={panelId} role="region" aria-labelledby={headingId} hidden={!isOpen} className={cn('overflow-hidden transition-all duration-300 ease-in-out', isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0')} data-id="element-19">
        <div className="p-6 pt-0 text-gray-600 leading-relaxed" data-id="element-20">{children}</div>
      </div>
    </div>;
}
interface AccordionProps {
  items: {
    title: string;
    content: React.ReactNode;
  }[];
}
export function Accordion({
  items
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full border border-gray-200 rounded-lg shadow-sm bg-white divide-y divide-gray-200" data-id="element-21">
      {items.map((item, index) => <AccordionItem key={index} title={item.title} isOpen={openIndex === index} onToggle={() => handleToggle(index)} index={index} data-id="element-22">
          {item.content}
        </AccordionItem>)}
    </div>;
}